import * as React from "react";
import { PolicyCreateForm } from "./form";

export const PolicyCreateInitializer: React.FC = () => {
  return <PolicyCreateForm />;
};
